(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desqelle-featured-product"] && !Shopify.designMode) return;
  try {
    
  const initializeDesqelleFeaturedProduct = (root) => {
    if (!root || root.dataset.dfpInitialized === 'true') return;
    root.dataset.dfpInitialized = 'true';

    const variantSelect = root.querySelector('[data-variant-select]');
    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-current-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const saleBadge = root.querySelector('[data-sale-badge]');
    const inventory = root.querySelector('.desqelle-featured-product__inventory');
    const inventoryText = root.querySelector('[data-inventory-text]');
    const skuRow = root.querySelector('.desqelle-featured-product__sku');
    const sku = root.querySelector('[data-sku]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const viewDetails = root.querySelector('[data-view-details]');
    const mainImage = root.querySelector('[data-dfp-main-image]');
    const thumbnails = [...root.querySelectorAll('[data-dfp-thumbnail]')];

    const setImage = (thumbnail) => {
      if (!thumbnail || !mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = thumbnail.dataset.imageUrl;
      mainImage.alt = thumbnail.dataset.imageAlt || '';
      thumbnails.forEach((item) => {
        const active = item === thumbnail;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => setImage(thumbnail));
    });

    const updateVariant = () => {
      if (!variantSelect) return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      const available = option.dataset.available === 'true';
      const managed = option.dataset.managed === 'true';
      const policy = option.dataset.policy;
      const inventoryQuantity = Number(option.dataset.inventory || 0);
      const threshold = Number(root.dataset.inventoryThreshold || 0);
      const showInventory = root.dataset.showInventory === 'true';
      const onSale = option.dataset.onSale === 'true';

      if (variantInput) variantInput.value = option.value;
      if (price) price.textContent = option.dataset.price || '';
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !onSale;
      }
      if (saleBadge) saleBadge.hidden = !onSale;

      if (inventory && inventoryText) {
        if (!available) {
          inventory.dataset.inventoryState = 'sold-out';
          inventoryText.textContent = root.dataset.soldOutLabel;
        } else if (showInventory && managed && inventoryQuantity > 0 && inventoryQuantity <= threshold) {
          inventory.dataset.inventoryState = 'low';
          inventoryText.textContent = `${root.dataset.lowStockLabel} ${inventoryQuantity}`;
        } else {
          inventory.dataset.inventoryState = 'available';
          inventoryText.textContent = root.dataset.inStockLabel;
        }
      }

      if (sku && skuRow) {
        sku.textContent = option.dataset.sku || '';
        skuRow.hidden = !option.dataset.sku;
      }

      if (addButton && addLabel) {
        addButton.disabled = !available;
        addLabel.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      }
      if (dynamicCheckout) dynamicCheckout.hidden = !available;

      if (quantityInput) {
        const minimum = Number(option.dataset.quantityMin || 1);
        const step = Number(option.dataset.quantityStep || 1);
        const ruleMaximum = Number(option.dataset.quantityMax || 0);
        let maximum = ruleMaximum;
        if (managed && policy === 'deny' && inventoryQuantity > 0) {
          maximum = maximum > 0 ? Math.min(maximum, inventoryQuantity) : inventoryQuantity;
        }
        quantityInput.min = String(minimum);
        quantityInput.step = String(step);
        quantityInput.value = String(minimum);
        if (maximum > 0) quantityInput.max = String(maximum);
        else quantityInput.removeAttribute('max');
      }

      const mediaId = option.dataset.imageId;
      if (mediaId) {
        const matchingThumbnail = thumbnails.find((thumbnail) => thumbnail.dataset.mediaId === mediaId);
        if (matchingThumbnail) setImage(matchingThumbnail);
      }

      if (viewDetails && root.dataset.productUrl) {
        viewDetails.href = `${root.dataset.productUrl}?variant=${option.value}`;
      }
    };

    if (variantSelect) variantSelect.addEventListener('change', updateVariant);

    const minus = root.querySelector('[data-quantity-minus]');
    const plus = root.querySelector('[data-quantity-plus]');
    const changeQuantity = (direction) => {
      if (!quantityInput) return;
      const step = Number(quantityInput.step || 1);
      const minimum = Number(quantityInput.min || 1);
      const maximum = quantityInput.max ? Number(quantityInput.max) : Infinity;
      const current = Number(quantityInput.value || minimum);
      const next = Math.min(maximum, Math.max(minimum, current + direction * step));
      quantityInput.value = String(next);
    };

    if (minus) minus.addEventListener('click', () => changeQuantity(-1));
    if (plus) plus.addEventListener('click', () => changeQuantity(1));

    updateVariant();
  };

  const initializeAllDesqelleFeaturedProducts = (scope = document) => {
    scope.querySelectorAll('[data-dfp-section]').forEach(initializeDesqelleFeaturedProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllDesqelleFeaturedProducts());
  } else {
    initializeAllDesqelleFeaturedProducts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllDesqelleFeaturedProducts(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
